module.exports = __webpack_public_path__ + "static/devi-6fbb9274ed3e26a87e650aefa0d1a980.jpg";